<svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="6" height="6" fill="#F0F0FA"/>
</svg>
